export const ifThen = (ifFn, thenFn) => (value) => {
    if (ifFn(value)) {
        return thenFn(value);
    }
    return value;
};
export const ifThenElse = (ifFn, thenFn, elseFn) => (value) => {
    if (ifFn(value)) {
        return thenFn(value);
    }
    return elseFn(value);
};
export const ifIs = (predicate, thenFn) => {
    return (value) => {
        if (predicate(value)) {
            return thenFn(value);
        }
        return value;
    };
};
export const ifIsElse = (predicate, thenFn, elseFn) => (value) => {
    if (predicate(value)) {
        return thenFn(value);
    }
    return elseFn(value);
};
export const If = {
    then: ifThen,
    thenElse: ifThenElse,
    is: ifIs,
    isElse: ifIsElse,
};
//# sourceMappingURL=ifThenElse.js.map